module.exports = __webpack_public_path__ + "static/img/product1.e7ff01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/clean/product1.png
// module id = 67b8
// module chunks = 0